import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <nav className="bg-cream sticky top-0 z-50 shadow-sm" data-id="element-103">
      <div className="container mx-auto px-4 py-4" data-id="element-104">
        <div className="flex justify-between items-center" data-id="element-105">
          <Link to="/" className="flex items-center" data-id="element-106">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/utRq69J5hAxbiGeb3Ckvjp/logo_jemi.png" alt="Jemi Baby Care Logo" className="h-14 w-auto" data-id="element-107" />
          </Link>
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8" data-id="element-108">
            <Link to="/" className="text-brown hover:text-brown-dark font-medium" data-id="element-109">
              Home
            </Link>
            <Link to="/shop" className="text-brown hover:text-brown-dark font-medium" data-id="element-110">
              Shop
            </Link>
            <Link to="/offerings" className="text-brown hover:text-brown-dark font-medium" data-id="element-111">
              Offerings
            </Link>
            <Link to="/doctor" className="text-brown hover:text-brown-dark font-medium" data-id="element-112">
              Speak to a Doctor
            </Link>
            <Link to="/about" className="text-brown hover:text-brown-dark font-medium" data-id="element-113">
              About
            </Link>
            <Link to="/blog" className="text-brown hover:text-brown-dark font-medium" data-id="element-114">
              Education Hub
            </Link>
            <Link to="/community" className="text-brown hover:text-brown-dark font-medium" data-id="element-115">
              Community
            </Link>
            <Link to="/faq" className="text-brown hover:text-brown-dark font-medium" data-id="element-116">
              FAQ
            </Link>
            <Link to="/contact" className="text-brown hover:text-brown-dark font-medium" data-id="element-117">
              Contact
            </Link>
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-118">
            <button onClick={toggleMenu} className="text-brown hover:text-brown-dark focus:outline-none" data-id="element-119">
              {isMenuOpen ? <X size={24} data-id="element-120" /> : <Menu size={24} data-id="element-121" />}
            </button>
          </div>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden mt-4 pb-4" data-id="element-122">
            <div className="flex flex-col space-y-4" data-id="element-123">
              <Link to="/" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-124">
                Home
              </Link>
              <Link to="/shop" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-125">
                Shop
              </Link>
              <Link to="/offerings" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-126">
                Offerings
              </Link>
              <Link to="/doctor" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-127">
                Speak to a Doctor
              </Link>
              <Link to="/about" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-128">
                About
              </Link>
              <Link to="/blog" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-129">
                Education Hub
              </Link>
              <Link to="/community" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-130">
                Community
              </Link>
              <Link to="/faq" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-131">
                FAQ
              </Link>
              <Link to="/contact" className="text-brown hover:text-brown-dark font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-132">
                Contact
              </Link>
            </div>
          </div>}
      </div>
    </nav>;
};
export default Navbar;